<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,2C11,1.45,10.55,1,10,1C10,1,10.219999999999999,1,10.219999999999999,1C9.879999999999999,0.4,9.24,0,8.5,0C7.76,0,7.12,0.4,6.779999999999999,1C6.779999999999999,1,7,1,7,1C6.45,1,6,1.45,6,2C6,2,6,3,6,3C6,3,11,3,11,3C11,3,11,2,11,2C11,2,11,2,11,2ZM13,2C13,2,12,2,12,2C12,2,12,4,12,4C12,4,5,4,5,4C5,4,5,2,5,2C5,2,4,2,4,2C3.45,2,3,2.45,3,3C3,3,3,15,3,15C3,15.55,3.45,16,4,16C4,16,13,16,13,16C13.55,16,14,15.55,14,15C14,15,14,3,14,3C14,2.45,13.55,2,13,2C13,2,13,2,13,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Clipboard',
} as DefineComponent
</script>
